// Multi-Level Navigation Menu Handler
document.addEventListener('DOMContentLoaded', function() {
  // Handle navigation between menu levels
  document.addEventListener('click', function(e) {
    const navigationButton = e.target.closest('[data-action="show-submenu"]');
    if (navigationButton) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const targetSubmenuId = navigationButton.getAttribute('data-target-submenu');
      const targetSubmenu = document.getElementById(targetSubmenuId);
      const currentMenuLevel = navigationButton.closest('[data-menu-level]');
      
      if (targetSubmenu && currentMenuLevel) {
        navigateToSubmenu(targetSubmenu, currentMenuLevel);
      }
    }
    
    // Handle back button navigation
    const backButton = e.target.closest('[data-action="go-back"]');
    if (backButton) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const currentSubmenu = backButton.closest('.submenu');
      if (currentSubmenu) {
        navigateBackFromSubmenu(currentSubmenu);
      }
    }
  });
  
  document.addEventListener('focusin', function(e) {
    const submenuElement = e.target.closest('.submenu, [data-action="show-submenu"], [data-action="go-back"]');
    if (submenuElement) {
      e.stopPropagation();
    }
  }, true);
  
  document.addEventListener('focusout', function(e) {
    const submenuElement = e.target.closest('.submenu, [data-action="show-submenu"], [data-action="go-back"]');
    if (submenuElement) {
      e.stopPropagation();
    }
  }, true);
  
  // Initialize carousel functionality
  initializeMenuCarousels();
  
  // Helper Functions
  function navigateToSubmenu(targetSubmenu, currentMenuLevel) {
    // Ensure the parent dropdown stays open
    const parentDropdown = targetSubmenu.closest('.DropdownMenuDefault');
    const parentMenuItem = parentDropdown ? parentDropdown.closest('.HorizontalList__Item') : null;
    
    if (parentMenuItem) {
      parentMenuItem.classList.add('is-expanded');
      const dropdownMenu = parentMenuItem.querySelector('.DropdownMenuDefault');
      if (dropdownMenu) {
        dropdownMenu.setAttribute('aria-hidden', 'false');
      }
    }
    
    // Hide the main menu when showing any submenu
    const mainMenu = document.querySelector('.menu-level--primary');
    if (mainMenu) {
      mainMenu.classList.add('submenu-active');
    }
    
    // If we're showing a second level submenu, also hide the first level submenu
    if (targetSubmenu.classList.contains('submenu--second')) {
      // Find the corresponding first level submenu by looking at the data-parent-menu attribute
      const parentMenuId = targetSubmenu.getAttribute('data-parent-menu');
      const firstLevelSubmenu = document.getElementById(parentMenuId);
      if (firstLevelSubmenu) {
        firstLevelSubmenu.classList.add('submenu-active');
      }
    }
    
    targetSubmenu.classList.add('active');
  }
  
  function navigateBackFromSubmenu(currentSubmenu) {
    // Ensure the parent dropdown stays open
    const parentDropdown = currentSubmenu.closest('.DropdownMenuDefault');
    const parentMenuItem = parentDropdown ? parentDropdown.closest('.HorizontalList__Item') : null;
    
    if (parentMenuItem) {
      parentMenuItem.classList.add('is-expanded');
      const dropdownMenu = parentMenuItem.querySelector('.DropdownMenuDefault');
      if (dropdownMenu) {
        dropdownMenu.setAttribute('aria-hidden', 'false');
      }
    }
    
    // Hide current submenu
    currentSubmenu.classList.remove('active');
    
    // If we're going back from a second level submenu, show the first level submenu
    if (currentSubmenu.classList.contains('submenu--second')) {
      // Find the corresponding first level submenu by looking at the data-parent-menu attribute
      const parentMenuId = currentSubmenu.getAttribute('data-parent-menu');
      const firstLevelSubmenu = document.getElementById(parentMenuId);
      if (firstLevelSubmenu) {
        firstLevelSubmenu.classList.remove('submenu-active');
        firstLevelSubmenu.classList.add('active');
      }
    } else {
      // If we're going back from a first level submenu, show the main menu
      const mainMenu = document.querySelector('.menu-level--primary');
      if (mainMenu) {
        mainMenu.classList.remove('submenu-active');
      }
      
      // Hide all submenus
      document.querySelectorAll('.submenu').forEach(submenu => {
        submenu.classList.remove('active');
        submenu.classList.remove('submenu-active');
      });
    }
  }

  function initializeMenuCarousels() {
    initializeProductCarousels();
  }
  
  function initializeProductCarousels() {
    const productCarousels = document.querySelectorAll('.MenuRight__Carousel');
    
    productCarousels.forEach(carousel => {
      if (!Flickity.data(carousel)) {
        const carouselConfig = JSON.parse(carousel.getAttribute('data-flickity-config') || '{}');
        const carouselInstance = new Flickity(carousel, carouselConfig);
        
        setupCarouselInteractions(carousel, carouselInstance, carouselConfig);
      }
    });
  }
  
  function setupCarouselInteractions(carousel, carouselInstance, config) {
    // Handle slide change events
    carousel.addEventListener('change.flickity', function(event, slideIndex) {
      console.log('Product carousel changed to slide:', slideIndex);
    });
    
    // Pause autoplay on hover for better UX
    const productItems = carousel.querySelectorAll('.MenuRight__Item');
    productItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        carouselInstance.pausePlayer();
      });
      
      item.addEventListener('mouseleave', function() {
        if (config.autoPlay) {
          carouselInstance.unpausePlayer();
        }
      });
    });
  }
});
